import {Component, Inject} from '@angular/core';
import {AppService} from '../../app.service';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';

@Component({
    selector: 'app-tab-options-bottomsheet',
    templateUrl: './tab-options-bottomsheet.component.html',
    styleUrl: './tab-options-bottomsheet.component.scss',
    standalone: false
})
export class TabOptionsBottomsheetComponent {
	constructor(
		public appService: AppService,
		private bottomSheetRef: MatBottomSheetRef<TabOptionsBottomsheetComponent>,
		@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
	) {

	}
	openLink(act, event: MouseEvent ): void {
		this.bottomSheetRef.dismiss(act);
		event.preventDefault();
	}
}
